export const TEXT_APP_ROUTES = {
  EMAIL_TEMPLATES: "/settings/email-template",
  RULES: "/automations/rules",
};
